var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPinGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18208_2698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.50024C9.60457 8.50024 10.5 7.60481 10.5 6.50024C10.5 5.39567 9.60457 4.50024 8.5 4.50024C7.39543 4.50024 6.5 5.39567 6.5 6.50024C6.5 7.60481 7.39543 8.50024 8.5 8.50024Z",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.50024C13.5 11.0002 8.5 14.5002 8.5 14.5002C8.5 14.5002 3.5 11.0002 3.5 6.50024C3.5 5.17416 4.02678 3.90239 4.96447 2.96471C5.90215 2.02703 7.17392 1.50024 8.5 1.50024C9.82608 1.50024 11.0979 2.02703 12.0355 2.96471C12.9732 3.90239 13.5 5.17416 13.5 6.50024Z",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18208_2698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinGray);
export default __webpack_public_path__ + "static/media/MapPinGray.f4607ee951aa45afaf52648625ee748a.svg";
export { ForwardRef as ReactComponent };